import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageTitleComponent } from '@shared/components/sections/page-title/page-title.component';
import { StepNavigatorComponent } from '@shared/components/ui/step-navigator/step-navigator.component';
import { IStepNavigatorConfig, StepDisplay, StepModes, StepUI } from '@shared/models/step-navigator';

import { InventoryRoutes } from '../inventory.routes';

@Component({
	selector: 'app-inventory',
	imports: [CommonModule, PageTitleComponent, StepNavigatorComponent, RouterOutlet],
	templateUrl: './inventory.component.html',
	styleUrl: './inventory.component.scss',
})
export class InventoryComponent {
	stepConfig: IStepNavigatorConfig = {
		ui: StepUI.WIZARD,
		mode: StepModes.ROUTER_OUTLET,
		displayType: StepDisplay.AUTO,
		showStepChevrons: false,
		showStepNumbers: false,
		showNavButtons: true,
		steps: [
			{
				title: {
					full: 'Items',
					tabs: 'Items',
				},
				icon: 'bi-boxes',
				route: [InventoryRoutes.ITEMS],
				disabled: false,
			},
			{
				title: {
					full: 'Categories',
					tabs: 'Categories',
				},
				icon: 'bi-tags',
				route: [InventoryRoutes.CATEGORIES],
				disabled: false,
			},
			{
				title: {
					full: 'Locations',
					tabs: 'Locations',
				},
				icon: 'bi-geo-alt',
				route: [InventoryRoutes.LOCATIONS],
				disabled: false,
			},
		],
	};
}
